import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608151f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["innerHTML"]

import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { FAQLanguageItem } from "@/types/help";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);
const activeName = ref(0);
var mainLanguageData = reactive<FAQLanguageItem[]>([
  {
    id: 1,
    questions: "how_to_use",
    answers: "how_to_use_doc",
  },
  {
    id: 2,
    questions: "trird_party",
    answers: "trird_party_doc",
  },
  {
    id: 3,
    questions: "remove_watermark",
    answers: "remove_watermark_doc",
  },
  {
    id: 4,
    questions: "pro_user_service",
    answers: "pro_user_service_doc",
  },
  {
    id: 5,
    questions: "company_user",
    answers: "company_user_doc",
  },
  {
    id: 6,
    questions: "pro_service_time",
    answers: "pro_service_time_doc",
  },
  {
    id: 7,
    questions: "set_month",
    answers: "set_month_doc",
  },
  {
    id: 8,
    questions: "not_wifi",
    answers: "not_wifi_doc",
  },
  {
    id: 9,
    questions: "max_number",
    answers: "max_number_doc",
  },
  {
    id: 10,
    questions: "how_to_invoice",
    answers: "how_to_invoice_doc",
  },
  {
    id: 11,
    questions: "contact_us",
    answers: "contact_us_doc",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createBlock(_component_el_collapse, {
    modelValue: activeName.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
    accordion: "",
    class: _normalizeClass(['box', { mobileSize: _unref(isMobile) }])
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainLanguageData), (item, index) => {
        return (_openBlock(), _createBlock(_component_el_collapse_item, {
          name: index,
          key: index
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", {
              class: "mainTitle",
              textContent: _toDisplayString(_ctx.$t(`faq.${item.questions}`))
            }, null, 8, _hoisted_1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: _ctx.$t(`faq.${item.answers}`)
            }, null, 8, _hoisted_2)
          ]),
          _: 2
        }, 1032, ["name"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "class"]))
}
}

})